module.exports = __webpack_public_path__ + "img/1.aea14c84.png";